import { render } from "./TeamForm.vue?vue&type=template&id=12c6e49b"
import script from "./TeamForm.vue?vue&type=script&lang=js"
export * from "./TeamForm.vue?vue&type=script&lang=js"

import "./TeamForm.vue?vue&type=style&index=0&id=12c6e49b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__